import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import {
  getAllProducts,
  createProduct,
  updateProduct,
  deleteProduct,
} from "../utils/productService";

export const useProducts = () => {
  const navigate = useNavigate();

  return useQuery({
    queryKey: ["products"],
    queryFn: getAllProducts,
    staleTime: 5 * 60 * 1000, // 5 minutes
    onError: (error) => {
      if (error.message.includes("401")) {
        Swal.fire({
          title: "Unauthorized",
          text: "Please log in again.",
          icon: "error",
        }).then(() => {
          localStorage.removeItem("userVASData");
          localStorage.removeItem("companyName");
          navigate("/login");
        });
      } else {
        Swal.fire({
          title: "Error",
          text: error.message || "Failed to fetch products",
          icon: "error",
        });
      }
    },
  });
};

export const useCreateProduct = () => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  return useMutation({
    mutationFn: createProduct,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["products"] });
      Swal.fire({
        title: "Success",
        text: "Product created successfully.",
        icon: "success",
      }).then(() => {
        navigate("/products");
      });
    },
    onError: (error) => {
      if (error.message.includes("401")) {
        Swal.fire({
          title: "Unauthorized",
          text: "Please log in again.",
          icon: "error",
        }).then(() => {
          localStorage.removeItem("userVASData");
          localStorage.removeItem("companyName");
          navigate("/login");
        });
      } else {
        Swal.fire({
          title: "Error",
          text: error.message || "Failed to create product",
          icon: "error",
        });
      }
    },
  });
};

export const useUpdateProduct = () => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  return useMutation({
    mutationFn: updateProduct,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["products"] });
      Swal.fire({
        title: "Success",
        text: "Product updated successfully.",
        icon: "success",
      }).then(() => {
        navigate("/products");
      });
    },
    onError: (error) => {
      if (error.message.includes("401")) {
        Swal.fire({
          title: "Unauthorized",
          text: "Please log in again.",
          icon: "error",
        }).then(() => {
          localStorage.removeItem("userVASData");
          localStorage.removeItem("companyName");
          navigate("/login");
        });
      } else {
        Swal.fire({
          title: "Error",
          text: error.message || "Failed to update product",
          icon: "error",
        });
      }
    },
  });
};

export const useDeleteProduct = () => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  return useMutation({
    mutationFn: deleteProduct,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["products"] });
      Swal.fire({
        title: "Success",
        text: "Product deleted successfully.",
        icon: "success",
      }).then(() => {
        navigate("/products");
      });
    },
    onError: (error) => {
      if (error.message.includes("401")) {
        Swal.fire({
          title: "Unauthorized",
          text: "Please log in again.",
          icon: "error",
        }).then(() => {
          localStorage.removeItem("userVASData");
          localStorage.removeItem("companyName");
          navigate("/login");
        });
      } else {
        Swal.fire({
          title: "Error",
          text: error.message || "Failed to delete product",
          icon: "error",
        });
      }
    },
  });
};